import React, { ReactElement } from 'react'

import MainLayout from 'ui/layouts/MainLayout/MainLayout'

function AuthenticatedApp(): ReactElement {
  return <MainLayout />
}

export default AuthenticatedApp
